import { buildModule } from '../utils';

import bulk from './bulk';

export default buildModule()
	.withSubmodules({
		bulk,
	});
